import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import CaptureScreen from "@/pages/CaptureScreen";
import AnalysisScreen from "@/pages/AnalysisScreen";
import ResultsScreen from "@/pages/ResultsScreen";
import AdminDashboard from "@/pages/AdminDashboard";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import { Toaster } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Session ID for tracking
const SESSION_ID = `s_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export const trackEvent = (eventType, step, metadata = {}) => {
  axios.post(`${API}/track`, { event_type: eventType, step, session_id: SESSION_ID, metadata }).catch(() => {});
};

function App() {
  const [capturedImage, setCapturedImage] = useState(null);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [referenceShade, setReferenceShade] = useState("");
  const [analysisMode, setAnalysisMode] = useState("single");

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js').catch(() => {});
    }
  }, []);

  const resetSession = () => {
    setCapturedImage(null);
    setAnalysisResult(null);
    setReferenceShade("");
    setAnalysisMode("single");
  };

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <PWAInstallPrompt />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage onReset={resetSession} />} />
          <Route path="/capture" element={<CaptureScreen onImageCaptured={setCapturedImage} />} />
          <Route path="/analyze" element={
            <AnalysisScreen image={capturedImage} referenceShade={referenceShade}
              setReferenceShade={setReferenceShade} analysisMode={analysisMode}
              setAnalysisMode={setAnalysisMode} onResult={setAnalysisResult} />
          } />
          <Route path="/results" element={
            <ResultsScreen result={analysisResult} image={capturedImage} onStartNew={resetSession} />
          } />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
